import {
    ChangeDetectionStrategy,
    Component,
    forwardRef,
    HostBinding,
    inject,
    input,
    model
} from '@angular/core';

import {
    AbstractControl,
    ControlContainer,
    FormGroupDirective,
    FormsModule,
    NG_VALIDATORS,
    NG_VALUE_ACCESSOR,
    ReactiveFormsModule,
    ValidationErrors
} from '@angular/forms';
import { Store } from '@ngxs/store';
import { ZSelectComponent } from '@shared/components/form-components/z-select/z-select.component';

import { SelectModule } from 'primeng/select';

@Component({
    selector: 'z-service-recurring',
    imports: [FormsModule, ReactiveFormsModule, SelectModule, ZSelectComponent],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ServiceRecurringComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: ServiceRecurringComponent
        }
    ],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ],
    templateUrl: './ServiceRecurring.component.html',
    styleUrl: './ServiceRecurring.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServiceRecurringComponent {
    @HostBinding('class') class?: string = 'flex flex-auto';

    protected rootFormGroup = inject(FormGroupDirective);
    label = input<string | undefined>('Παρεχόμενη Υπηρεσία');
    autocomplete = input<string | undefined>(undefined);
    id = input<string | undefined>(undefined);
    optionLabel = input<string | undefined>('Title');
    optionValue = input<string | undefined>('id');
    options = model<ServiceRecurringModel[] | undefined>([
        {
            id: 1,
            Title: 'Απαξ' //Απαξ, recurringService, continuousService
        }
        // {
        //     id: 2,
        //     Title: 'Επαναλαμβανόμενη Υπηρεσία'
        // },
        // {
        //     id: 3,
        //     Title: 'Διαρκής Υπηρεσία'
        // }
    ]);
    placeholder = input<string | undefined>(undefined);
    store = inject(Store);

    constructor() {
        // this.store
        //   .select(DigitalClientCardGraphQLSchemaSelectors.FetchSelector('', ''))
        //   .pipe(takeUntilDestroyed())
        //   .subscribe((value) => {
        //     this.options.set(value?.data?.Fetch);
        //   });
    }

    /* NG_VALUE_ACCESSOR Implementation */
    // https://blog.angular-university.io/angular-custom-form-controls/
    disabled?: boolean;
    model: any;
    onModelChange: Function = () => {};
    onModelTouched: Function = () => {};

    writeValue(obj: any): void {
        this.model = obj;
    }
    registerOnChange(fn: any): void {
        this.onModelChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onModelTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    validate(control: AbstractControl): ValidationErrors | null {
        return null;
    }
    registerOnValidatorChange?(fn: () => void): void {
        // throw new Error('Method not implemented.');
    }
    /* /NG_VALUE_ACCESSOR Implementation */
}

export interface ServiceRecurringModel {
    id: number;
    Title: string;
}
